module.exports = __webpack_public_path__ + "img/mbicon.ccdfc617.svg";